import type { PlanRequestBatchInput } from "./plan-import-types";
export function requestCategory(materialCode: string): PlanRequestBatchInput["lines"][number]["category"] {
    return materialCode.startsWith("4") ? "Ambalaj" : "Hammadde";
}
export function requestPriority(requiredAt: string): PlanRequestBatchInput["lines"][number]["priority"] {
    const today = new Intl.DateTimeFormat("en-CA", {
        timeZone: "Europe/Istanbul",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).format(new Date());
    const days = Math.ceil((Date.parse(requiredAt) - Date.parse(today)) / 86400000);
    if (days <= 0)
        return "CRITICAL";
    if (days <= 7)
        return "HIGH";
    return "NORMAL";
}
export function requestQuantity(value: number, unit: string) {
    return ["ADET", "KOLİ", "PAKET", "RULO", "PALET", "SET"].includes(unit.toLocaleUpperCase("tr-TR")) ? Math.ceil(value) : Math.ceil(value * 1000) / 1000;
}
